type TimelineEvent = {
  id: string;
  seq: number;
  type: string;
  nodeId?: string | null;
  deletedAt?: string | null;
};

export const getResettableEventIds = (
  events: readonly TimelineEvent[],
  hasPermission: boolean,
): Set<string> => {
  if (!hasPermission) return new Set<string>();

  const latestByNode = new Map<string, TimelineEvent>();

  for (const event of events) {
    if (!event.type.startsWith("node:")) continue;
    if (!event.nodeId || event.deletedAt) continue;

    const current = latestByNode.get(event.nodeId);
    if (!current || event.seq > current.seq) {
      latestByNode.set(event.nodeId, event);
    }
  }

  return new Set([...latestByNode.values()].map((event) => event.id));
};
